import BlockProperties from '@/components/blocks/Admin/Properties/BlockProperties';
import BlockDraftsProperties from '@/components/blocks/Admin/Properties/BlockDraftsProperties';
import BlockDeletedProperties from '@/components/blocks/Admin/Properties/BlockDeletedProperties';
import BlockEditProperty from '@/components/blocks/Admin/Properties/BlockEditProperty';
import BlockSingleProperty from '@/components/blocks/Properties/BlockSingleProperty';
import BlockPropertyHistory from '@/components/blocks/Properties/BlockPropertyHistory';
import BlockVerifiedProperties from '@/components/blocks/BlockVerifiedProperties';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';

export default [
	{
		path: 'properties',
		name: 'Properties',
		component: BlockProperties,
		meta: {
			title: `Properties - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/drafts',
		name: 'DraftProperties',
		component: BlockDraftsProperties,
		meta: {
			title: `Drafts Properties - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/deleted',
		name: 'DeletedProperties',
		component: BlockDeletedProperties,
		meta: {
			title: `Deleted Properties - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/edit/:id',
		name: 'EditProperty',
		component: BlockEditProperty,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Edit Property - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/clone/:id',
		name: 'CloneProperty',
		component: BlockEditProperty,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Clone Property - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/new',
		name: 'NewProperty',
		component: BlockEditProperty,
		props: {
			edit: false
		},
		meta: {
			title: `New Property - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'properties/single/:id',
		name: 'SinglePropertyAdmin',
		component: BlockSingleProperty,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Property - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'properties/history/:id',
		name: 'PropertyHistoryAdmin',
		component: BlockPropertyHistory,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Property history - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'verified-properties',
		name: 'VerifiedProperties',
		component: BlockVerifiedProperties,
		meta: {
			title: `Verified properties - ${process.env.VUE_APP_NAME}`
		}
	}
];
